<odx-content-box class="file-content-box">
  <odx-area-header>
    <h6 class="odx-title-6" data-testid="heading.newAsset">{{ title }}</h6>
    <odx-area-header-content>
      <odx-action-group>
        <button odxButton (click)="onDelete()">
          <odx-icon name="delete"></odx-icon>
        </button>
      </odx-action-group>
    </odx-area-header-content>
  </odx-area-header>

  <form odxForm [formGroup]="newFileForm">
    <odx-form-field i18n-label="@@newProject.emptyFloorplanNameForm.label" label="Name" odxLayout="6">
      <input
        formControlName="name"
        odxFormFieldControl
        i18n-placeholder="@@newProject.emptyFloorplanNameForm.placeholder"
        placeholder="Name"
        data-testid="input.newAsset"
      />
    </odx-form-field>

    @if ((businessScope$ | async) === BusinessScope.MONITORING && isFloorplan) {
      <odx-form-field i18n-label="@@projectDetails.floorplan.form.tags.label" label="Tags">
        <odx-select data-testid="floorplan-tags" multiple formControlName="tags" odxFormFieldControl>
          @for (item of tagList$ | async | odxAutocompleteSearchFilter; track item) {
            <odx-select-option [value]="item">{{ item | translateFloorplanTag }}</odx-select-option>
          }
          <input
            placeholder="Nach Tag suchen..."
            i18n-placeholder="@@projectDetails.floorplan.form.tags.placeholder"
            odxSelectSearchField="Kein Tag gefunden"
            i18n-odxSelectSearchField="@@projectDetails.floorplan.form.tags.noResult"
          />
        </odx-select>
      </odx-form-field>
    }

    <!-- prettier-ignore-attribute style -->
    <div class="file-wrapper" [ngStyle]="{ 'background-image': 'url(' + fileUrl + ')' }">
      @if (!fileUrl) {
        <div class="file-placeholder h-100" i18n="@@newProject.emptyFloorplanName">Leerer Grundrissplan</div>
      }
    </div>

    @if (isFloorplan) {
      <odx-form-field
        i18n-label="@@projectDetails.floorplan.form.description.label"
        label="Beschreibung"
        odxLayout="12"
        class="form-description"
      >
        <textarea formControlName="description" odxFormFieldControl></textarea>
      </odx-form-field>
    }

    <button type="submit" class="hidden" #submitButton></button>
  </form>
</odx-content-box>
